module.exports = __webpack_public_path__ + "static/slider3-min-9c5a75777f255dc9a28f37f9c1dee2aa.jpg";